import Vue from 'vue';
import Vuex from 'vuex';
import { createStore } from 'vuex-extensions';
import createMultiTabState from 'vuex-multi-tab-state';
import * as actions from "./actions";
import activityLog from "./activityLog";
import admins from "./admins";
import auditPanel from "./auditPanel";
import audits from "./audits";
import auth from "./auth";
import common from "./common";
import conceptActions from "./conceptActions";
import conceptDetach from "./conceptDetach";
import conceptEntities from "./conceptEntities";
import flags from "./flags";
import * as mutations from "./mutations";
import options from "./options";
import permissions from "./permissions";
import reports from "./reports";
import roles from "./roles";
import splitPanel from "./splitPanel";
import splitPanelSearch from "./splitPanel/search";
import tCodes from "./tCodes";
import userActivity from "./userActivity";
import webSearch from "./webSearch";
import users from "./users";
Vue.use(Vuex);
var modules = {
  auth: auth,
  admins: admins,
  roles: roles,
  permissions: permissions,
  splitPanel: splitPanel,
  splitPanelSearch: splitPanelSearch,
  webSearch: webSearch,
  activityLog: activityLog,
  options: options,
  conceptDetach: conceptDetach,
  tCodes: tCodes,
  auditPanel: auditPanel,
  audits: audits,
  conceptActions: conceptActions,
  conceptEntities: conceptEntities,
  common: common,
  reports: reports,
  userActivity: userActivity,
  flags: flags,
  users: users
};

/*
 * ide-helper, should contain same modules as const Store.
 */
var ideHelper = new Vuex.Store({
  modules: modules,
  actions: actions
});
void ideHelper;
var Store = createStore(Vuex.Store, {
  modules: modules,
  mutations: mutations,
  actions: actions,
  plugins: [createMultiTabState({
    statesPaths: ['userActivity']
  })],
  // enable strict mode (adds overhead!)
  // for dev mode only
  strict: process.env.DEV
});
export default Store;